import axios, { HttpStatusCode } from "axios"

export default class EventsApi {
  static getEventById = async (eventId) => {
    try {
      const res = await axios.get(`/api/events/${eventId}`)
      return res.data;
    }
    catch(error) {
      console.log("Get event Error", error);
      throw error;
    }
  }
}